import React from 'react';
import { withProps } from 'recompose';
import { FacilityBreadcrumbs } from 'components/facility/FacilityBreadcrumbs';
import { Crumb } from 'components/core/Breadcrumbs';

export const enhance = withProps(({ unit }) => ({
	crumbs: [
		<Crumb
			key="unit"
			label="Reserve Unit"
			to={unit.url}
			isLast
		/>,
	],
}));

export default enhance(FacilityBreadcrumbs);
